import React, { useState, useEffect } from 'react';
import { Fade } from 'react-reveal';
import { useSelector } from 'react-redux';

import styles from './Calendar.module.css';
import { generateCalendar } from '../../../../utils/generateCalendar';

const Calendar = ({ dbData, banquet }) => {
  const colorData = useSelector((state) => state.colors); // Redux 상태 구독

  let year;
  let month;
  let day;

  if (banquet) {
    ({ year, month, day } = dbData.banquetDate);
  } else {
    ({ year, month, day } = dbData.weddingDate);
  }

  const [calendarData, setCalendarData] = useState([]);

  useEffect(() => {
    setCalendarData(generateCalendar(year, month));
  }, [year, month]);

  return (
    <div className={styles.calendar_wrapper}>
      <Fade bottom duration={1200}>
        <h2>
          {year}년 {month}월
        </h2>
      </Fade>
      <div id='Calendar' className={styles.Calendar}>
        <table>
          <Fade bottom duration={1400}>
            <thead>
              <tr>
                <th
                  style={{
                    backgroundColor: `rgba(${colorData.point}, 1)`,
                    borderColor: `rgba(${colorData.point}, 1)`,
                  }}
                >
                  일
                </th>
                <th
                  style={{
                    backgroundColor: `rgba(${colorData.point}, 1)`,
                    borderColor: `rgba(${colorData.point}, 1)`,
                  }}
                >
                  월
                </th>
                <th
                  style={{
                    backgroundColor: `rgba(${colorData.point}, 1)`,
                    borderColor: `rgba(${colorData.point}, 1)`,
                  }}
                >
                  화
                </th>
                <th
                  style={{
                    backgroundColor: `rgba(${colorData.point}, 1)`,
                    borderColor: `rgba(${colorData.point}, 1)`,
                  }}
                >
                  수
                </th>
                <th
                  style={{
                    backgroundColor: `rgba(${colorData.point}, 1)`,
                    borderColor: `rgba(${colorData.point}, 1)`,
                  }}
                >
                  목
                </th>
                <th
                  style={{
                    backgroundColor: `rgba(${colorData.point}, 1)`,
                    borderColor: `rgba(${colorData.point}, 1)`,
                  }}
                >
                  금
                </th>
                <th
                  style={{
                    backgroundColor: `rgba(${colorData.point}, 1)`,
                    borderColor: `rgba(${colorData.point},1)`,
                  }}
                >
                  토
                </th>
              </tr>
            </thead>
          </Fade>
          <tbody>
            {calendarData.map((week, i) => (
              <tr>
                <Fade bottom duration={1600 + i * 100}>
                  {week.map((dayOfCalendar) =>
                    dayOfCalendar.day ? (
                      <td
                        key={dayOfCalendar.day}
                        style={{
                          ...(new Date(year, month - 1, dayOfCalendar.day).toDateString() ===
                            new Date(
                              `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
                            ).toDateString() && {
                            border: `2px solid rgba(${colorData.point}, 0.75)`,
                            backgroundColor: `rgba(${colorData.main}, 0.5)`,
                            fontWeight: 'bold',
                            color: `rgba(${colorData.point}, 1)`,
                          }),
                        }}
                      >
                        {dayOfCalendar.day}
                      </td>
                    ) : (
                      <td key={new Date().getTime() - Math.random() * 1000} />
                    ),
                  )}
                </Fade>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Calendar;
